<template lang="pug">
  .component-client-action-buttons
    .dropdown-buttons
      ModalReveal(ref="editReveal")
        button.button.warning(slot="trigger", type="button") Edit
        DocumentTypeForm(v-model="item" )
        ActionButton(slot="footer", :action="edit") Save
      ActionButton(:action="remove", confirm) Delete
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import ModalReveal from '../../foundation/ModalReveal'
import ActionButton from "../ActionButton.vue";
import {EventBus} from "../../../../eventBus";
import DocumentTypeForm from "../../forms/DocumentTypeForm.vue";

export default {
  name: 'DocumentTypeButtons',
  components: {DocumentTypeForm, ActionButton, ModalReveal},
  data() {
    return {
      entity: null
    }
  },
  created() {
  },
  methods: {
    remove: function () {
      return KeplerBackofficeSdk.documentTypes.select(this.item).remove(() => {
        MaggieHelper.notification('delete-esit', 'Document type removed')
        EventBus.$emit('reload-list')
      })
    },
    edit() {
      return KeplerBackofficeSdk.documentTypes.select(this.item).edit(this.item, () => {
        EventBus.$emit('reload-list')
        this.$refs.editReveal.close()
      })
    }
  },
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DocumentTypeButtons.vue?505a8e66